//components
import { ConceptDisplay } from './ConceptDisplay.js';
import { uuid} from 'component-library';
//styles
import styles from './front-end-styles.css';

/*this component creates the presentation of each concept for the frontend of the site inside a dropdown
Props:
	concept: string, the concept this is fro
	frontend_pre_fix: string, any prefix to the title
	more_info_output: object of settings to display
	data: object, the data to present
	defaultOpen: bool, to default to open or not
*/
export function ConceptDisplayDropDown(props) {
	let { 
		more_info_output, 
		frontend_pre_fix, 
		concept, 
		data, 
		defaultOpen,
	} = props,
		title = data[concept];
		
	//legacy for when this was an array TODO remove
	if ( more_info_output !== undefined && Array.isArray( more_info_output ) ) {
		more_info_output.reduce((a, v) => ({ ...a, [v]: v}), {}) 
	}
			
	//if local numbering is set, use it
	if ( more_info_output?.[concept+'_local_numbering'] !== undefined ){
		title = data[concept+'_local_numbering']+': '+title;
	}
	//if frontend prefix is set add it in front of the title
	if (frontend_pre_fix !== undefined && frontend_pre_fix !== '' ) {
		title = frontend_pre_fix+title;
	}

	return <div className={styles.conceptHolder} id={uuid()}> 
		<h3 className={styles.title +' hide-heading-nav'} >{title}</h3>
		<details className={styles.conceptDetails} open={defaultOpen} > 
			<summary className={styles.conceptSummary}>More information on this {concept} </summary>
			<div className={styles.conceptMoreInfoContent}>
				<ConceptDisplay 
					concept={concept} 
					frontend_pre_fix={frontend_pre_fix}
					more_info_output={more_info_output}
					data={data}
				/>

			</div>
		</details>
	</div>; 
}
